import { render, staticRenderFns } from "./fenxian.vue?vue&type=template&id=12499ffa&scoped=true&"
import script from "./fenxian.vue?vue&type=script&lang=js&"
export * from "./fenxian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12499ffa",
  null
  
)

export default component.exports